/**
 * Time utility functions for ShiftGrid
 */

/**
 * Convert time string "HH:mm" to minutes from midnight for START times
 * "00:00" is treated as 0 (midnight at start of day)
 */
export const startTimeToMinutes = (time: string): number => {
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
};

/**
 * Convert time string "HH:mm" to minutes from midnight for END times
 * "00:00" is treated as 24:00 (1440 minutes) - midnight at end of day
 * "00:30" is treated as 24:30 (1470 minutes) - 30 min after midnight
 */
export const endTimeToMinutes = (time: string): number => {
  const [hours, minutes] = time.split(":").map(Number);
  // If hour is 0 (midnight), treat as 24:00+ for end times
  const adjustedHours = hours === 0 ? 24 : hours;
  return adjustedHours * 60 + minutes;
};

/**
 * Convert minutes from midnight to time string "HH:mm"
 * Handles values >= 1440 (24:00) by wrapping around
 */
export const minutesToTime = (totalMinutes: number): string => {
  const hours = Math.floor(totalMinutes / 60) % 24;
  const minutes = totalMinutes % 60;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};

/**
 * Calculate duration in hours between two times
 */
export const calculateDurationHours = (startTime: string, endTime: string): number => {
  const startMinutes = startTimeToMinutes(startTime);
  const endMinutes = endTimeToMinutes(endTime);
  return (endMinutes - startMinutes) / 60;
};

/**
 * Format duration in minutes to a human-readable string
 */
export const formatDuration = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours === 0) return `${mins}m`;
  if (mins === 0) return `${hours}h`;
  return `${hours}h ${mins}m`;
};
